import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoCapitalize]'
})
export class AutoCapitalizeDirective {

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const original = event.target.value;
    const cursorPos = event.target.selectionStart;
    const formatted = this.formatValue(original);

    if (formatted !== original) {
      this.el.nativeElement.value = formatted;
      
      // Adjust cursor position based on formatting changes
      const newCursorPos = cursorPos + (formatted.length - original.length);
      setTimeout(() => {
        event.target.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    }
  }

  /** Main formatter for name & address fields */
  private formatValue(value: string): string {
    if (!value) return value;

    // Replace multiple spaces with single space but don't trim trailing space if user is typing
    value = value.replace(/\s{2,}/g, ' ');

    // Capitalize each word
    value = value
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());

    // Keep common address abbreviations uppercase
    const uppercaseWords = ['NW', 'NE', 'SW', 'SE', 'PO', 'BOX', 'APT', 'UNIT'];

    value = value
      .split(' ')
      .map(word => uppercaseWords.includes(word.toUpperCase()) ? word.toUpperCase() : word)
      .join(' ');

    return value;
  }
}